import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '../models/api.model';
import { DashboardStats } from '../models/booking.model';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class BookingService {
  private apiUrl = `${environment.apiUrl}/booking/bookings/`;
  private dashboardUrl = `${environment.apiUrl}/booking/dashboard-stats/`;

  constructor(private http: HttpClient) {}

  list(params?: HttpParams): Observable<PaginatedResponse<any>> {
    return this.http.get<PaginatedResponse<any>>(this.apiUrl, { params });
  }

  get(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}${id}/`);
  }

  create(data: any): Observable<any> {
    return this.http.post<any>(this.apiUrl, data);
  }

  update(id: number, data: any): Observable<any> {
    return this.http.patch<any>(`${this.apiUrl}${id}/`, data);
  }

  confirm(id: number): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}${id}/confirm/`, {});
  }

  cancel(id: number): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}${id}/cancel/`, {});
  }

  complete(id: number): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}${id}/complete/`, {});
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}${id}/`);
  }

  getDashboardStats(): Observable<DashboardStats> {
    return this.http.get<DashboardStats>(this.dashboardUrl);
  }
}